/**
 * Browser-side crisis notifier. Compares two `escalado` counters
 * across polling cycles and fires a Notification API alert when
 * the count increases.
 *
 * No server push subscription required, works only while /admin is open.
 * Persistent push (when /admin is NOT open) is already handled by sw.js +
 * PASTOR_EMAIL alerts via Resend.
 */

const STORAGE_KEY = "cm_crisis_notify_pref_v1"; // "on" | "off" | (unset)

export const crisisNotifyPref = {
  get: () => {
    try { return window.localStorage.getItem(STORAGE_KEY) || ""; }
    catch { return ""; }
  },
  set: (v) => {
    try { window.localStorage.setItem(STORAGE_KEY, v); }
    catch { /* ignore */ }
  },
};

export const notificationsSupported = () =>
  typeof window !== "undefined" && "Notification" in window;

export const notificationStatus = () => {
  if (!notificationsSupported()) return "unsupported";
  return Notification.permission; // "granted" | "denied" | "default"
};

/** Asks the browser for permission. Resolves with the new status string. */
export const requestNotificationPermission = async () => {
  if (!notificationsSupported()) return "unsupported";
  if (Notification.permission !== "default") return Notification.permission;
  try {
    const status = await Notification.requestPermission();
    return status;
  } catch {
    return "denied";
  }
};

/** Fires a single CRISE notification with deep-link to /admin. */
export const fireCrisisNotification = (delta) => {
  if (!notificationsSupported() || Notification.permission !== "granted") return;
  try {
    const body = delta === 1
      ? "Uma nova mensagem de crise precisa de atenção pastoral."
      : `${delta} novas mensagens de crise precisam de atenção.`;
    const n = new Notification("⚠️ Crise detectada, Casa de Medeiros", {
      body,
      tag: "cm-crisis-alert", // collapse repeat alerts
      icon: "/icons/icon-192.png",
      badge: "/icons/icon-192.png",
      requireInteraction: true,
    });
    n.onclick = () => {
      window.focus();
      window.location.href = "/admin";
      n.close();
    };
  } catch { /* ignore */ }
};
